<div class="p-d-flex p-flex-column p-mt-3" [formGroup]="otpremnicaForm">
  <!-- Tabela stavki dokumenta -->
  <p-table
    [value]="stavkeOtpremnice.controls"
    styleClass="p-datatable-striped p-datatable-gridlines"
    [(selection)]="selectedStavke"
    dataKey="redniBroj"
  >
    <!-- START HEADER -->
    <ng-template pTemplate="header">
      <!-- header columns -->
      <tr class="columns">
        <th style="width: 22vw">Naziv/šifra</th>
        <th style="width: 5vw">Gtin</th>
        <th style="width: 7vw" class="p-text-right">Količina</th>
        <th style="width: 5vw">Jedinica mere</th>
        <th style="width: 5vw">Akcizna kategorija</th>
        <th style="width: 5vw">Tip pakovanja/Gramaža/Litraža/Gustina</th>
        <th style="width: 5vw">Šifra robne marke</th>
        <th style="width: 1vw"></th>
      </tr>
    </ng-template>

    <!-- START BODY -->

    <!-- Rows -->
    <ng-template
      pTemplate="body"
      let-stavka
      let-rowIndex="rowIndex"
      let-expanded="expanded"
    >
      <ng-container formArrayName="stavkeDto">
        <tr [formGroupName]="rowIndex">

          <!-- redni broj -->
          <!-- <td style="vertical-align: middle" class="p-text-center">
                  <div class="celija">
                    {{ stavka.get('redniBroj').value }}
                  </div>
                </td> -->
          <!-- naziv predmet stavke -->
          <td (click)="onArtikalInputClick()">
            <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                ">
              <kodit-predmet-stavke-eotpremnica-input
                title="Stavke"
                [predmetStavkeFormGroup]="
                  stavkeOtpremnice.at(rowIndex).get('predmetStavkeDto')
                "
                (onNazivChange)="updateRezultate($event, rowIndex)"
                [ngClass]="
                  rowIndex < brojPocetnihStavki
                    ? 'p-disabled inputFullWidth celija'
                    : ''
                "
              ></kodit-predmet-stavke-eotpremnica-input>

              <!-- <div
                class="p-mt-2"
                 *ngIf="
                  stavka.get('predmetStavkeDto.tipPredmeta').value ===
                  tipPredmetaRoba
                "
              >
                <kodit-magacin-dropdown
                  [magacinCtrl]="stavka.get('magacinId')"
                  [ngClass]="
                    rowIndex < brojPocetnihStavki
                      ? 'p-disabled inputFullWidth celija'
                      : ''
                  "
                ></kodit-magacin-dropdown>
              </div> -->
            </div>
          </td>
          <td class="p-text-right">
            <div
              [ngClass]="
                rowIndex < brojPocetnihStavki
                  ? 'p-disabled inputFullWidth p-d-flex p-ai-center p-flex-column p-flex-md-row gap-12 celija'
                  : 'inputFullWidth p-d-flex p-ai-center p-flex-column p-flex-md-row gap-12 celija'
              "
            >
              <!-- KOL -->
              <div>
                <kodit-text-input
                  [formCtrl]="stavka.get('gtin')"
                ></kodit-text-input>
              </div>
            </div>
          </td>
          <!-- kol. -->
          <td class="p-text-right">
            <div
              [ngClass]="
                rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth p-d-flex p-ai-center p-flex-column p-flex-md-row gap-12 celija'
                  : 'inputFullWidth p-d-flex p-ai-center p-flex-column p-flex-md-row gap-12 celija'
              "
            >
              <!-- KOL -->
              <div>
                <kodit-number-input
                  [formCtrl]="stavka.get('kolicina')"
                ></kodit-number-input>
              </div>
            </div>
          </td>
          <td class="p-text-right">
            <div
              [ngClass]="
                rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
              "
            >
              <kodit-jedinica-mere-dropdown
                [jedinicaMereGroup]="stavka.get('jedinicaMereDto')"
                ctrlPlaceholder="&#45;&#45;"
              >
              </kodit-jedinica-mere-dropdown>
            </div>
          </td>

          <td class="p-text-right">
            <div
              [ngClass]="
                rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
              "
            >
              <kodit-tip-akcizne-kategorije-dropdown
                [formCtrl]="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')"
                (onItemChange)="onTipAkcizneKategorijeChange($event.value, rowIndex)"
              ></kodit-tip-akcizne-kategorije-dropdown>
            </div>
          </td>

          <td class="p-text-right">
             <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                "
              *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value === null"
            >
              --
            </div>
            <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                "
              *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value === tipDuvan
                  && stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !== null">
              <kodit-tip-pakovanja-duvana-dropdown
                [formCtrl]="stavka.get('akciznaKategorijaDto.tipPakovanjaDuvana')"
                (onItemChange)="onTipAkcizneKategorijeChange($event)"
              ></kodit-tip-pakovanja-duvana-dropdown>
            </div>
            <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                "
                *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value ===  tipNikotin
                      && stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !== null">
              <kodit-text-input
                [formCtrl]="stavka.get('akciznaKategorijaDto.vrednost')"
              ></kodit-text-input>
            </div>
            <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                "
                 *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !==  tipNikotin
                    && stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !==  tipDuvan
                      && stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !== null">
              <kodit-number-input
                class="fullWidthNumber"
                [formCtrl]="stavka.get('akciznaKategorijaDto.vrednost')"
              ></kodit-number-input>
            </div>
          </td>
          <td>
            <div
              [ngClass]="
              rowIndex < brojPocetnihStavki || disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
                "
            >
              <div class="p-mt-2"
                *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value === tipDuvan"
              >
                <kodit-text-input
                  [formCtrl]="stavka.get('akciznaKategorijaDto.sifraRobneMarke')"
                ></kodit-text-input>

              </div>
            </div>
            <div
              class="celija p-text-center"
              *ngIf="stavka.get('akciznaKategorijaDto.tipAkcizneKategorije')?.value !== tipDuvan"
            >
              --
            </div>
          </td>
          <td style="vertical-align: middle" class="p-text-center">
            <div class="celija">
              <!-- <p-tableCheckbox [value]="stavka.value"></p-tableCheckbox> -->
              <button
                *ngIf="
                  rowIndex >= brojPocetnihStavki
                "
                pButton
                pRipple
                type="button"
                icon="far fa-trash-alt"
                class="p-button-text p-button-danger"
                pTooltip="Ukloni stavku sa računa"
                (click)="deleteStavka(rowIndex)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>

  <!-- Button za dodavanje stavke -->
  <div class="p-d-flex p-mt-3">
    <button
      pButton
      pRipple
      type="button"
      icon="fas fa-plus"
      class="p-button-outlined"
      (click)="addEmptyStavka()"
      label="Nova stavka"
      pTooltip="Dodaj novu stavku na račun"
    ></button>
  </div>

  <!-- Rezultat pretrage -->
  <div
    class="layout-sidebar-right rezultati"
    [ngClass]="{ 'layout-sidebar-right-active': shouldDisplayRezultate }"
  >
    <kodit-rezultat-pretrage-stavke
      *ngIf="shouldDisplayRezultate"
      [searchValue]="rezultatiSearchValue"
      [excludeTipovePredmeta]="excludeTipovePredmeta"
      (onPredmetStavkeAdd)="handleAddPredmetStavke($event)"
    ></kodit-rezultat-pretrage-stavke>
  </div>
</div>
